import { IconNames } from '@icon/assets';

/** A destination row in the desktop side menu. */
export interface SideMenuItem {
	title: string;
	/** The outline glyph; the active row swaps in its `-fill` twin. */
	icon: IconNames;
	route: string;
	dataCy: string;
}

/** The footer's five tabs, as the side menu names them in the handoff. */
export const SIDE_MENU_ITEMS: readonly SideMenuItem[] = [
	{ title: 'بازار کالا', icon: 'market-view', route: '/market', dataCy: 'side-menu-market' },
	{ title: 'پرتفوی', icon: 'portfolio', route: '/portfolio', dataCy: 'side-menu-portfolio' },
	{ title: 'سفارشات', icon: 'basket', route: '/orders', dataCy: 'side-menu-orders' },
	{ title: 'کیف‌پول', icon: 'wallet', route: '/wallet', dataCy: 'side-menu-wallet' },
	{ title: 'سایر', icon: 'more', route: '/menu', dataCy: 'side-menu-more' }
] as const;

/** The account card's gear: the same تنظیمات سایر opens. */
export const SIDE_MENU_SETTINGS_ROUTE = '/settings';
